window.countrySelectEvent = function (countrySelector, zoneSelector, zone_id = 0) {
    const country = $(countrySelector);
    const zone = $(zoneSelector);
    customAjaxRequest('index.php?route=account/account/country&country_id=' + country.val(), 'get', [], function () {
        country.after('<i class="fa fa-circle-o-notch fa-spin"></i>');
    }, function (json) {
        $('.fa-spin').remove();
        let options_html = '<option value=""> --- Te rugăm alege --- </option>';

        if (json['zone'] && json['zone'] != '') {
            for (i = 0; i < json['zone'].length; i++) {
                options_html += '<option value="' + json['zone'][i]['zone_id'] + '"';
                if (zone_id && json['zone'][i]['zone_id'] == zone_id) {
                    options_html += ' selected="selected"';
                }
                options_html += '>' + json['zone'][i]['name'] + '</option>';
            }
        } else {
            options_html += '<option value="0" selected="selected"> --- Nimic --- </option>';
        }
        zone.html(options_html);

        if (zone_id) {
            zone.trigger('change');
        }

    });
}
window.setupCountrySelectEvent = function (countrySelector, zoneSelector, zone_id = 0) {
    const country = $(countrySelector);
    country.change(function () {
        countrySelectEvent(countrySelector, zoneSelector, zone_id)
    })
    country.trigger('change');
}

window.zoneSelectEvent = function (zoneSelector, citySelector, cityVal = '') {
    const zone = $(zoneSelector);
    const city = $(citySelector);
    if(zone.val()) {
        customAjaxRequest('https://alexandrucocieru.com/gls/?judet=' + zone.find('option:selected').text(), 'get', [], function () {
            zone.after('<i class="fa fa-circle-o-notch fa-spin"></i>');
        }, function (json) {
            $('.fa-spin').remove();
            let options_html = '<option value=""> --- Te rugăm alege --- </option>';

            if (json && json != '') {
                for (i = 0; i < json.length; i++) {
                    options_html += '<option value="' + json[i]['localitate'] + '" data-zip="' + json[i]['zipcode'] + '"';
                    if (json[i]['localitate'] == cityVal) {
                        options_html += ' selected="selected"';
                    }
                    options_html += '>' + json[i]['localitate'] + '</option>';
                }
            } else {
                options_html += '<option value="0" selected="selected"> --- Nimic --- </option>';
            }
            city.html(options_html);

            if (cityVal) {
                city.trigger('change');
            }

        });
    }
}
window.setupZoneSelectEvent = function (zoneSelector, citySelector, cityVal = '') {
    const zone = $(zoneSelector);
    zone.change(function () {
        zoneSelectEvent(zoneSelector, citySelector, cityVal)
    })
    zone.trigger('change');
}

window.citySelectEvent = function (citySelector, postcodeSelector) {
    const city = $(citySelector);
    const postcode = $(postcodeSelector);
    postcode.val(city.find('option:selected').data('zip'));

}
window.setupCitySelectEvent = function (citySelector, postcodeSelector) {
    const city = $(citySelector);
    city.change(function () {
        citySelectEvent(citySelector, postcodeSelector)
    })
    city.trigger('change');
}


